/**
 * The one distinction a reader can act on differently when a governed-data surface fails to
 * load: a lost session (sign in again) versus everything else (retry the same request). Every
 * surface's request layer already throws the same shape for this - `status: 401`, or the
 * pre-flight `name: 'AuthorizationError'` thrown before a request ever reaches the network (see
 * `services/common.ts`) - so this reads that shape once rather than each surface re-deriving it.
 */
export type FailureCause = 'auth' | 'unknown';

function statusOf(error: unknown): number | undefined {
  if (!error || typeof error !== 'object') {
    return undefined;
  }
  const status = (error as { status?: unknown }).status;
  return typeof status === 'number' ? status : undefined;
}

function nameOf(error: unknown): string | undefined {
  if (!error || typeof error !== 'object') {
    return undefined;
  }
  const name = (error as { name?: unknown }).name;
  return typeof name === 'string' ? name : undefined;
}

export function failureCause(error: unknown): FailureCause {
  if (statusOf(error) === 401 || nameOf(error) === 'AuthorizationError') {
    return 'auth';
  }
  return 'unknown';
}
